module.exports = __webpack_public_path__ + "img/typhoon_yellow.6a03c6b7.gif";